const mediaItems = [
  {
    title: '《长安十二时辰》导演剪辑版独家上线',
    desc: '雷佳音、易烊千玺主演，4K修复版在玫瑰视频独家放送，新增30分钟未播出片段',
    duration: '48集全',
    platform: '红桃视频',
    img: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20city%20at%20night%20with%20lanterns%20and%20traditional%20architecture%2C%20Tang%20dynasty%20aesthetic%2C%20warm%20candlelight%20illumination%2C%20bustling%20market%20street%2C%20cinematic%20composition%2C%20historical%20drama%20atmosphere&width=800&height=450&seq=media-01&orientation=landscape',
  },
  {
    title: '《流浪地球3》幕后纪录片抢先看',
    desc: '吴京、刘德华领衔，揭秘中国科幻电影制作全流程，从概念设计到特效合成的完整记录',
    duration: '120分钟',
    platform: '茄子视频',
    img: 'https://readdy.ai/api/search-image?query=Futuristic%20space%20station%20interior%20with%20holographic%20displays%2C%20sleek%20metallic%20surfaces%2C%20blue%20ambient%20lighting%2C%20sci-fi%20movie%20set%20aesthetic%2C%20cinematic%20production%20design%2C%20high-tech%20atmosphere&width=800&height=450&seq=media-02&orientation=landscape',
  },
  {
    title: '年度国漫《深海》加长版震撼上线',
    desc: '田晓鹏导演七年磨一剑，水墨粒子特效惊艳全球，糖心视频独家加长版含完整制作特辑',
    duration: '135分钟',
    platform: '糖心视频',
    img: 'https://readdy.ai/api/search-image?query=Dreamlike%20underwater%20world%20with%20colorful%20bioluminescent%20creatures%2C%20flowing%20ink%20particles%2C%20deep%20ocean%20blue%20gradient%2C%20surreal%20Chinese%20animation%20aesthetic%2C%20magical%20atmosphere%2C%20ethereal%20lighting&width=800&height=450&seq=media-03&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 text-center">
          视频精选
        </h2>
        <p className="mt-2 text-sm text-foreground-500 text-center">
          编辑精选优质内容，精彩不容错过
        </p>

        <div className="mt-8 md:mt-10 grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {mediaItems.map((item, i) => (
            <article
              key={i}
              className="group bg-background-100 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-48 md:h-56 overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute bottom-3 right-3 px-2 py-0.5 bg-foreground-950/70 text-background-50 text-xs rounded whitespace-nowrap">
                  {item.duration}
                </span>
                <span className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-14 h-14 flex items-center justify-center rounded-full bg-primary-500/80 text-background-50 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <i className="ri-play-fill text-2xl"></i>
                </span>
              </div>
              <div className="p-4 md:p-5">
                <span className="text-xs text-accent-500 font-medium bg-accent-100/80 px-2 py-0.5 rounded whitespace-nowrap">
                  {item.platform}
                </span>
                <h3 className="mt-2 text-base font-heading font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2">
                  {item.title}
                </h3>
                <p className="mt-2 text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}